import { postAxios, getAxios } from '@/lib/axios';

export const loginApi = {
  // 账号登录 @liyunfei
  accountLogin(data) {
    return postAxios('/admin/login/account', data);
  },

  // 修改密码 @liyunfei
  updatePwd(data) {
    return postAxios('/admin/login/updatePwd', data);
  },

  // 退出登录 @liyunfei
  logout() {
    return getAxios('/admin/login/logout');
  }
};
